import { createUserApi } from '@e-learning/core';
import type { UserDetailResponse, UserDetailUserGroup } from '@e-learning/core';
import { useEffect, useState } from 'react';
import { api } from '../../../../api/client';
import { authStorage } from '../../../../auth';

const userApi = createUserApi(api);

export interface UseStudentUserProfileResult {
  user: UserDetailResponse | null;
  userGroups: UserDetailUserGroup[];
  loading: boolean;
  error: boolean;
}

/**
 * Carrega GET v1/User/{id} com o `userId` guardado no auth (localStorage).
 */
export function useStudentUserProfile(): UseStudentUserProfileResult {
  const [user, setUser] = useState<UserDetailResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const userId = authStorage.getUserId();
    if (!userId) {
      setLoading(false);
      setUser(null);
      setError(false);
      return;
    }

    setLoading(true);
    setError(false);

    userApi
      .fetchUserById(userId)
      .then(data => {
        if (cancelled) return;
        setUser(data);
        setError(data == null);
      })
      .catch(() => {
        if (cancelled) return;
        setUser(null);
        setError(true);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return {
    user,
    userGroups: user?.userGroups ?? [],
    loading,
    error,
  };
}
